document.addEventListener('DOMContentLoaded', () => {

  /* ========================================
     MAIN IMAGE + THUMBNAILS
  ======================================== */

  const mainImage = document.getElementById('TFDMainImage');
  const thumbs = [...document.querySelectorAll('.tfd-thumb')];

  let currentIndex = thumbs.findIndex(
    thumb => thumb.classList.contains('active')
  );

  if (currentIndex < 0) currentIndex = 0;

  function updateGallery(index) {

    if (!thumbs.length || !mainImage) return;

    if (index < 0) {
      index = thumbs.length - 1;
    }

    if (index >= thumbs.length) {
      index = 0;
    }

    const activeThumb = thumbs[index];

    mainImage.src = activeThumb.dataset.image;

    thumbs.forEach(item => {
      item.classList.remove('active');
    });

    activeThumb.classList.add('active');

    activeThumb.scrollIntoView({
      behavior: 'auto',
      inline: 'center',
      block: 'nearest'
    });

    currentIndex = index;
  }

  thumbs.forEach((thumb, index) => {

    thumb.addEventListener('click', () => {
      updateGallery(index);
    });

  });

  /* ========================================
     THUMBNAIL ARROWS
  ======================================== */

  const prevBtn = document.querySelector('.tfd-thumb-prev');
  const nextBtn = document.querySelector('.tfd-thumb-next');

  if (prevBtn) {

    prevBtn.addEventListener('click', () => {
      updateGallery(currentIndex - 1);
    });

  }

  if (nextBtn) {

    nextBtn.addEventListener('click', () => {
      updateGallery(currentIndex + 1);
    });

  }

  /* ========================================
     QUANTITY
  ======================================== */

  const minusBtn = document.querySelector('.tfd-qty-minus');
  const plusBtn = document.querySelector('.tfd-qty-plus');
  const qtyInput = document.querySelector('.tfd-quantity input');

  if (minusBtn && plusBtn && qtyInput) {

    minusBtn.addEventListener('click', function () {

      let qty = parseInt(qtyInput.value, 10) || 1;

      if (qty > 1) {
        qtyInput.value = qty - 1;
      }

    });

    plusBtn.addEventListener('click', function () {

      let qty = parseInt(qtyInput.value, 10) || 1;

      qtyInput.value = qty + 1;

    });

  }

  /* ========================================
     ACCORDION
     Only one open at a time
  ======================================== */

  const accordions = document.querySelectorAll(
    '.tfd-accordion details'
  );

  accordions.forEach(item => {

    item.addEventListener('toggle', () => {

      if (item.open) {

        accordions.forEach(other => {

          if (other !== item) {
            other.removeAttribute('open');
          }

        });

      }

    });

  });

  /* ========================================
     IMAGE ZOOM
  ======================================== */

  const mainImageWrap =
    document.querySelector('.tfd-main-image');

  const zoomImage =
    mainImageWrap?.querySelector('img');

  if (mainImageWrap && zoomImage) {

    mainImageWrap.addEventListener('mousemove', (e) => {

      const rect =
        mainImageWrap.getBoundingClientRect();

      const x =
        ((e.clientX - rect.left) / rect.width) * 100;

      const y =
        ((e.clientY - rect.top) / rect.height) * 100;

      zoomImage.style.transformOrigin =
        `${x}% ${y}%`;

      zoomImage.style.transform =
        'scale(1.8)';

    });

    mainImageWrap.addEventListener('mouseleave', () => {

      zoomImage.style.transformOrigin =
        'center center';

      zoomImage.style.transform =
        'scale(1)';

    });

  }
/* ========================================
   VARIANT SYSTEM
======================================== */

const variantJson = document.getElementById('TFDVariantsJson');

if (variantJson) {

  const variants = JSON.parse(variantJson.textContent);
const colorInputs = document.querySelectorAll(
  '.tfd-option-values[data-option-name="Color"] input[type="radio"]'
);

const sizeInputs = document.querySelectorAll(
  '.tfd-option-values[data-option-name="Size"] input[type="radio"]'
);

const hasOnlyOneSize =
  sizeInputs.length === 1;

  function updateVariantState(changeImage = false) {

    const selectedColor =
      document.querySelector(
        '[data-option-name="Color"] input:checked'
      )?.value;

    if (!selectedColor) return;

   const availableSizes =
  variants
    .filter(variant => {

      return (
        variant.available &&
        (
          variant.option1 === selectedColor ||
          variant.option2 === selectedColor
        )

      );

    })
    .map(variant => {

      return (
        variant.option1 === selectedColor
          ? variant.option2
          : variant.option1
      );

    });
    if (hasOnlyOneSize) {

  sizeInputs.forEach(input => {

    input.disabled = false;
    input.checked = true;

    const wrapper =
      input.closest('.tfd-option-value');

    if (wrapper) {

      wrapper.style.opacity = '1';
      wrapper.style.pointerEvents = 'auto';

    }

  });

}

    sizeInputs.forEach(input => {

      const wrapper =
        input.closest('.tfd-option-value');

      const available =
        availableSizes.includes(input.value);

      input.disabled = !available;

      if (wrapper) {

        wrapper.style.opacity =
          available ? '1' : '.35';

        wrapper.style.pointerEvents =
          available ? 'auto' : 'none';

      }

      if (
        input.checked &&
        !available
      ) {

        input.checked = false;

      }

    });

    let activeSize =
      document.querySelector(
        '[data-option-name="Size"] input:checked'
      );

    if (!activeSize) {

      activeSize =
        [...sizeInputs].find(
          input => !input.disabled
        );

      if (activeSize) {
        activeSize.checked = true;
      }

    }

    const selectedSize =
      activeSize?.value;

    if (!selectedSize) return;
console.log({
  color: selectedColor,
  size: selectedSize
});
   const selectedVariant =
  variants.find(variant => {

    const values = [
      variant.option1,
      variant.option2,
      variant.option3
    ];

    return (
      values.includes(selectedColor) &&
      values.includes(selectedSize)
    );

  });
console.log(
  'Variant Updated:',
  selectedVariant.id,
  selectedVariant.title
);
    if (!selectedVariant) return;

    document
      .querySelectorAll(
        'input[name="id"]'
      )
      .forEach(input => {

        input.value =
          selectedVariant.id;

      });

    console.log(
      'Variant Updated:',
      selectedVariant.id,
      selectedVariant.title
    );

if (
  changeImage &&
  selectedVariant?.featured_image?.src
) {

  let imageSrc =
    selectedVariant.featured_image.src;

  if (
    imageSrc.startsWith('//')
  ) {

    imageSrc =
      'https:' + imageSrc;

  }

  mainImage.src =
    imageSrc;

}

  }

  colorInputs.forEach(input => {

    input.addEventListener(
      'change',
      () => updateVariantState(true)
    );

  });

  sizeInputs.forEach(input => {

    input.addEventListener(
      'change',
      () => updateVariantState(false)
    );

  });

  updateVariantState(false);

}
});